import { BROWSER_OS_PLATFORM } from '@/react/constants';

export const NEW_LINE_BREAKER = BROWSER_OS_PLATFORM === 'win' ? '\r\n' : '\n';
